import { Button } from '@progress/kendo-react-buttons';
import { Dialog, DialogActionsBar } from '@progress/kendo-react-dialogs';
import { useAppSelector } from '../../hooks/redux';
import { RootState } from '../../store';
import {
  selectConfirmDialogParam,
  selectConfirmDialogVisible,
} from '../../store/slices/confirm.slice';
import { DialogProps } from './dialog.model';
import { FlyoutHeader } from '../flyouts/components/FlyoutHeader';

// TODO: Update this component to use Proceed & Cancel pattern rather than rely on proceed with specific values
export function AppConfirm({
  className = '',
  id,
  proceed,
  onClose,
  dialogTitle,
  dialogSubTitle,
  headerIcon,
  yesLabel,
  noLabel,
  children,
  hideNoLabel,
  hideYesLabel,
  customYesLabel: CustomYesLabel,
  yesDisabled = false,
  visibleOverride,
  closeIcon = true,
}: DialogProps) {
  const visible =
    useAppSelector((state: RootState) => selectConfirmDialogVisible(state, id)) || visibleOverride;
  const targetId = useAppSelector((state: RootState): any => selectConfirmDialogParam(state, id));

  const defaultOnClose = () => {
    proceed(false, targetId);
  };

  return (
    visible && (
      <Dialog className={`app-confirm ${className}`}>
        <FlyoutHeader
          title={dialogTitle}
          subTitle={dialogSubTitle}
          onCloseClick={onClose ?? defaultOnClose}
          icon={headerIcon}
          closeIcon={closeIcon}
        />
        {children}
        {(!hideNoLabel || !hideYesLabel || CustomYesLabel) && (
          <DialogActionsBar>
            {!hideNoLabel && (
              <Button
                themeColor={'primary'}
                rounded={'medium'}
                fillMode={'outline'}
                onClick={() => proceed(false, targetId)}
              >
                {noLabel ?? 'No'}
              </Button>
            )}
            {!hideYesLabel && (
              <Button
                disabled={yesDisabled}
                themeColor={'primary'}
                rounded={'medium'}
                fillMode={'solid'}
                onClick={() => proceed(true, targetId)}
              >
                {yesLabel ?? 'Yes'}
              </Button>
            )}
            {CustomYesLabel}
          </DialogActionsBar>
        )}
      </Dialog>
    )
  );
}
